var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faq"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},_vm._l((_vm.faqs),function(item,index){return _c('FaqItem',{key:index,attrs:{"item":item}})}),1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }